import applicationForCredit from './applicationForCredit';
import searchIssueCredit from './searchIssueCredit';
import searchRecieveCredit from './searchRecieveCredit';
import detailOrAcceptCredit from './detailOrAcceptCredit';
import registerForCredit from './registerForCredit';
import claimForCredit from './claimForCredit';
import issuing from './issuing';
import acceptance from './acceptance';

export default {
  ...applicationForCredit,
  ...searchIssueCredit,
  ...searchRecieveCredit,
  ...detailOrAcceptCredit,
  ...registerForCredit,
  ...claimForCredit,
  ...issuing,
  ...acceptance,
};
